export class user {
    id: string;
    fullname: string;
    email: string;
    IsUser: boolean;
    createdDate: Date;
    modifiedDate: Date;
    clientId: string;
    desc: string;
    waiterTo:string;
    resName: string;
    
    constructor() {
        this.id = '0';
        this.fullname = '';
        this.email = '';
        this.IsUser = false;
        this.createdDate = new Date();
        this.modifiedDate = new Date();
        this.clientId = '';
        this.desc='';
        this.waiterTo='';
    }
};



// WEBPACK FOOTER //
// ./src/shared/user.ts